/* jshint esversion: 6 */
import React from 'react';
import MultiBanner from 'app/components/InfoBanner/Banners/MultiBanner.jsx';

const promotions = [
    // {
    //     'id': 'ratelimit_banner_50',
    //     'name': 'Rate Limit Banner 50',
    //     'creative': 'ratelimit_banner.50',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'faster_updates_banner',
    //     'name': 'Faster Updates Banner',
    //     'creative': 'faster_updates_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'hashtags_banner_basic',
    //     'name': 'Hashtags Banner Basic',
    //     'creative': 'hashtags_banner_basic.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'everqueue_banner_basic',
    //     'name': 'Everqueue Banner Basic',
    //     'creative': 'everqueue_banner_basic.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'instagram_output_banner',
    //     'name': 'Instagram Output Banner',
    //     'creative': 'instagram_output_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'instagram_biolink_banner',
    //     'name': 'Instagram Bio Link Banner',
    //     'creative': 'instagram_biolink_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'pinterest_banner',
    //     'name': 'Auto Post to Pinterest Banner',
    //     'creative': 'pinterest_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'reddit_output_banner',
    //     'name': 'Reddit Output Banner',
    //     'creative': 'reddit_output_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'share_tweets_banner',
    //     'name': 'Share Tweets Banner',
    //     'creative': 'share_tweets_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'echo_banner',
    //     'name': 'Echo Banner',
    //     'creative': 'echo_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'discord_output_banner',
    //     'name': 'Discord Output Banner',
    //     'creative': 'discord_output_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'mastodon_output_banner',
    //     'name': 'Mastodon Output Banner',
    //     'creative': 'mastodon_output_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_post_tool_banner',
    //     'name': 'New Posting Tool Banner',
    //     'creative': 'new_post_tool_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': '50_off_3',
    //     'name': '50% Off 3 Months Coupon',
    //     'creative': '50_off_3.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_bluesky_banner',
    //     'name': 'New Bluesky Banner',
    //     'creative': 'new_bluesky_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_tiktok_banner',
    //     'name': 'New TikTok Banner',
    //     'creative': 'new_tiktok_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_threads_banner_learn',
    //     'name': 'New Threads Banner Learn',
    //     'creative': 'new_threads_banner.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'new_threads_banner_connect',
    //     'name': 'New Threads Banner Connect',
    //     'creative': 'new_threads_banner.2',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'free_plan_ending_promo',
    //     'name': 'Free Plan Ending',
    //     'creative': 'free_plan_ending_promo.2',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'ai_hashtags',
    //     'name': 'AI Hashtags Banner',
    //     'creative': 'ai_hashtags.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'bluesky_is_here',
    //     'name': 'Bluesky Is Here Banner',
    //     'creative': 'bluesky_is_here.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'instagram_all_networks',
    //     'name': 'Instagram All Networks',
    //     'creative': 'instagram_all_networks.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'facebook_all_networks',
    //     'name': 'Facebook All Networks',
    //     'creative': 'facebook_all_networks.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'tiktok_all_networks',
    //     'name': 'TikTok All Networks',
    //     'creative': 'tiktok_all_networks.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'facebook_to_youtube_try',
    //     'name': 'Facebook To YouTube (Try now)',
    //     'creative': 'facebook_to_youtube_try.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'facebook_to_youtube_easy',
    //     'name': 'Facebook To YouTube (Easy)',
    //     'creative': 'facebook_to_youtube_easy.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'instagram_to_youtube_try',
    //     'name': 'Instagram To YouTube (Try now)',
    //     'creative': 'instagram_to_youtube_try.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'instagram_to_youtube_easy',
    //     'name': 'Instagram To YouTube (Easy)',
    //     'creative': 'instagram_to_youtube_easy.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'tiktok_to_youtube_try',
    //     'name': 'TikTok To YouTube (Try now)',
    //     'creative': 'tiktok_to_youtube_try.1',
    //     'position': 'top-promo-bar-basic'
    // },
    // {
    //     'id': 'tiktok_to_youtube_easy',
    //     'name': 'TikTok To YouTube (Easy)',
    //     'creative': 'tiktok_to_youtube_easy.1',
    //     'position': 'top-promo-bar-basic'
    // },
    {
        'id': 'summer_promo',
        'name': 'Summer Promo Final',
        'creative': 'summer_promo_final.1',
        'position': 'top-promo-bar-basic'
    },
];

class BasicBanner extends React.Component {
    render() {
        let constants = this.props.app.config.constants,
            imageUrl = this.props.app.config.assetsUrl + this.props.app.config.imageUrl,
            rateLimitContent = (
                <span><a href='https://support.dlvrit.com/hc/en-us/articles/115000131673-New-Basic-Plan-Limits?utm_source=basic.limit&utm_medium=app.banner' className="inline" target="_blank">Post more than 10 items daily?</a> Unlock unlimited posting.</span>
            ),
            allContent = [
                // {
                //     icon: 'icon ion-ios-infinite',
                //     content: ' Post more than 50 items monthly? Unlock unlimited posting.',
                //     linkDestination: '/account/subscription/new?utm_source=basic.limit&utm_medium=app.banner',
                //     linkContent: 'try it free'
                // },
                // {
                //     icon: 'icon ion-ios-bolt',
                //     content: ' Want to instantly post new items? Unlock real time updates.',
                //     linkDestination: '/account/subscription/new?utm_source=basic.updates&utm_medium=app.banner',
                //     linkContent: 'try it free'
                // },
                // {
                //     icon: 'icon ion-pound',
                //     content: ' Automatically add #hashtags to every post. ',
                //     linkDestination: '/account/subscription/new?utm_source=basicHashtags&utm_medium=app.banner',
                //     linkContent: 'try it free'
                // },
                // {
                //     icon: 'ds-icon icon-everqueue',
                //     content: 'EverQueue: Auto recycle your social media posts. ',
                //     linkDestination: '/account/subscription/new?plan=9&utm_source=everqueue&utm_medium=app.banner',
                //     linkContent: 'check it out'
                // },
                // {
                //     icon: 'fa fa-instagram',
                //     content: ' Auto post to Instagram.',
                //     linkDestination: 'https://dlvrit.com/instagram-scheduler',
                //     linkContent: 'Get started'
                // },
                // {
                //     icon: 'fa fa-link',
                //     content: ' Automated Instagram Link in Bio Page.',
                //     linkDestination: 'https://dlvrit.com/auto-instagram-link-in-bio',
                //     linkContent: 'Learn more'
                // },
                // {
                //     icon: 'fa fa-pinterest',
                //     content: ' Auto post to Pinterest.',
                //     linkDestination: '/account/subscription/new&utm_source=basicHashtags&utm_medium=app.banner',
                //     linkContent: 'try it free'
                // }
                // {
                //     icon: 'fa fa-reddit-alien',
                //     content: ' Auto post to Reddit.',
                //     linkDestination: 'https://dlvrit.com/automate/reddit',
                //     linkContent: 'Get started'
                // },
                // {
                //     icon: 'ds-icon icon-x',
                //     content: ' Share Tweets across social media.',
                //     linkDestination: 'https://dlvrit.com/automate/twitter',
                //     linkContent: 'Learn more'
                // },
                // {
                //     icon: 'fa fa-recycle',
                //     content: ' Auto repost your best content.',
                //     linkDestination: 'https://dlvrit.com/recycle-social-media-posts',
                //     linkContent: 'Learn more'
                // },
                // {
                //     icon: 'ds-icon icon-discord',
                //     content: ' Auto post to Discord.',
                //     linkDestination: 'https://dlvrit.com/automate/discord',
                //     linkContent: 'Get started'
                // },
                // {
                //     icon: 'ds-icon icon-mastodon',
                //     content: ' Auto post to Mastodon.',
                //     linkDestination: 'https://dlvrit.com/mastodon-auto-poster/',
                //     linkContent: 'Get started'
                // },
                // {
                //     icon: 'icon ion-ios-color-wand',
                //     content: ' New! Easily create and schedule customized posts.',
                //     linkDestination: '/content/post',
                //     linkContent: 'Check it out'
                // },
                // {
                //     icon: 'icon ion-android-star',
                //     content: '50% off first three months.',
                //     linkDestination: '/account/subscription/new?code=50FOR3',
                //     linkContent: 'PROMO CODE: 50FOR3'
                // },
                // {
                //     icon: 'fa fa-bullhorn',
                //     content: ' New! Auto post to Bluesky Social.',
                //     linkDestination: 'https://dlvrit.com/bluesky-auto-poster/',
                //     linkContent: 'Learn More'
                // },
                // {
                //     icon: 'ds-icon icon-tiktok',
                //     content: ' New! Auto schedule and post to TikTok.',
                //     linkDestination: '/config/socials?add=true',
                //     linkContent: 'Connect Now'
                // },
                // {
                //     icon: 'ds-icon icon-nextdoor',
                //     content: ' New! Auto post to Nextdoor Public Agencies.',
                //     linkDestination: '/config/socials?add=true',
                //     linkContent: 'Connect Now'
                // }
                // {
                //     icon: 'ds-icon icon-threads',
                //     content: ' New! Auto schedule and post to Threads.',
                //     //linkDestination: '/config/socials?add=true',
                //     linkDestination: 'https://support.dlvrit.com/hc/en-us/articles/26339365528603-How-to-create-a-Threads-account',
                //     linkContent: 'Learn More'
                // },
                // {
                //     icon: 'ds-icon icon-threads',
                //     content: ' Threads is here! Add yours today.',
                //     linkDestination: '/config/socials?add=true',
                //     linkContent: 'Connect Now'
                // },
                // {
                //     icon: 'icon ion-android-stopwatch',
                //     content: 'Our free plan ended September 10th. Get Pro for $99 / year.',
                //     linkDestination: '/promo',
                //     linkContent: 'Get our best price'
                // },
                // {
                //     icon: '',
                //     content: 'New! ✨ AI Powered Auto Hashtags.',
                //     linkDestination: 'https://dlvrit.com/ai-smart-hashtags/',
                //     linkContent: 'Learn more'
                // },
                // {
                //     icon: 'ds-icon icon-bluesky',
                //     content: ' Bluesky is here! Add yours today.',
                //     linkDestination: '/config/socials?add=true',
                //     linkContent: 'Connect Now'
                // },
                // {
                //     icon: 'fa fa-instagram',
                //     content: ' Share your instagram posts as native photos.',
                //     linkDestination: '/share/automate/new/inputs?social=true',
                //     linkContent: 'Start posting'
                // },
                // {
                //     icon: <img src={`${imageUrl}/svg-logos/instagram-color-icon.svg`}/>,
                //     content: 'Share Instagram Photos & Reels to all networks.',
                //     linkDestination: '/share/automate/new/inputs/instagram',
                //     linkContent: 'Start Sharing'
                // },
                // {
                //     icon: <img src={`${imageUrl}/svg-logos/facebook.svg`}/>,
                //     content: 'Share Facebook Photos & Videos to all networks.',
                //     linkDestination: '/share/automate/new/inputs/facebook',
                //     linkContent: 'Start Sharing'
                // },
                // {
                //     icon: 'ds-icon icon-tiktok',
                //     content: 'New! Auto share TikTok videos to all networks.',
                //     linkDestination: '/share/automate/new/inputs/tiktok',
                //     linkContent: 'Start Sharing'
                // },
                // {
                //     icon: 'fa fa-youtube-play',
                //     content: 'Auto upload Facebook videos to YouTube.',
                //     linkDestination: '/share/automate/new/inputs/facebook',
                //     linkContent: 'Try it now'
                // },
                // {
                //     icon: 'fa fa-youtube-play',
                //     content: 'Auto upload Facebook videos to YouTube.',
                //     linkDestination: '/share/automate/new/inputs/facebook',
                //     linkContent: 'Easy set up'
                // },
                // {
                //     icon: 'fa fa-youtube-play',
                //     content: 'Auto upload Instagram videos to YouTube.',
                //     linkDestination: '/share/automate/new/inputs/instagram',
                //     linkContent: 'Try it now'
                // },
                // {
                //     icon: 'fa fa-youtube-play',
                //     content: 'Auto upload Instagram videos to YouTube.',
                //     linkDestination: '/share/automate/new/inputs/instagram',
                //     linkContent: 'Easy set up'
                // },
                // {
                //     icon: 'fa fa-youtube-play',
                //     content: 'Auto upload TikTok videos to YouTube.',
                //     linkDestination: '/share/automate/new/inputs/tiktok',
                //     linkContent: 'Try it now'
                // },
                // {
                //     icon: 'fa fa-youtube-play',
                //     content: 'Auto upload TikTok videos to YouTube.',
                //     linkDestination: '/share/automate/new/inputs/tiktok',
                //     linkContent: 'Easy set up'
                // },
                {
                    icon: 'fa fa-bolt',
                    content: 'Last chance: One year of Pro for $99',
                    linkDestination: '/promo',
                    linkContent: 'Get best price'
                },
            ];

      
        return (
            <MultiBanner
                {...this.props}
                promotions={promotions}
                content={allContent} />
        );
    }

};

BasicBanner.displayName = "BasicBanner";

BasicBanner.defaultProps = {
    pubLevel: 0
};

export default BasicBanner;
